<template>
  <div>
    <div
      v-show="show > 0 && dismissed == 0"
      class="alert-main"
    >
      <div class="container-fluid">
        <div
          class="alert alert-warning alert-with-icon alert-dismissable fade in"
          role="alert"
        >
          <div class="alert-icon">
            <span
              aria-hidden="true"
              data-flex-icon="core|notification-warning"
              class="
                flex-icon
                ft-fw ft
                tfont-var-exclamation-triangle-fill
                ft-size-200
              "
            />
          </div>

          <div
            class="alert-message"
            v-html="message"
          />
          <button
            v-if="allowdismiss>0"
            type="button"
            class="close alert-close"
            data-dismiss="alert"
            aria-label="Close"
            @click="saveInteraction"
          >
            <span
              aria-hidden="true"
              data-flex-icon="delete-ns"
              class="flex-icon ft-fw ft tfont-var-x ft-size-200"
            />
          </button>
        </div>
      </div>
    </div>

    <div id="reset-dismissals">
      <button
        v-if="isadmin>0 && showDismissal()"
        :disabled="count < 1"
        @click="resetInteractions()"
      >
        Reset {{ count }} dismissed Alert(s)
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userid: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    isadmin: {
      type: [String, Boolean],
      "default": false,
    },
    allowdismiss: {
      type: [String, Boolean],
      "default": true,
    },
    show: {
      type: [String, Boolean],
      "default": true,
    },
    currentcount: {
      type: [String, Number],
      "default": 0,
    },
  },
  data() {
    return {
      count: this.currentcount,
      dismissed: 0,
    };
  },
  mounted() {
    $('#app_local_maintenance_alerts').appendTo('.totaraNav');

    if (this.showDismissal()) {
      $('#reset-dismissals').prependTo('.form-buttons');
    }
  },
  methods: {
    showDismissal() {
      if (window.location.href.includes("/admin/settings.php?section=local_maintenance_alerts")) {
        return true;
      }
      return false;
    },
    saveInteraction() {
      axios
        .get('/local/maintenance_alerts/actions/ajax_handler.php', {
          params: {
            action: 'save_interaction',
            sesskey: M.cfg.sesskey,
          },
        })
        .then((response) => {
          this.count = response.data;
          this.dismissed = 1;
        })
        .catch((error) => {
          this.data = error;
        });
    },
    resetInteractions() {
      if (confirm('Do you want to reset all current dismissals?')) {
        axios
          .get('/local/maintenance_alerts/actions/ajax_handler.php', {
            params: {
              action: 'reset_interactions',
              sesskey: M.cfg.sesskey,
            },
          })
          .then((response) => {
            this.dismissed = 0;
            this.count = 0;
          })
          .catch((error) => {
            this.data = error;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#app_local_maintenance_alerts {
  .alert-main {
    border-bottom: 1px solid #cccccc;
    height: 72px!important;
    background-color: #ffffff;

    .container-fluid {
      height: 72px!important;
    }
  }

  .alert-warning .alert-icon {
    background: unset;
  }

  .tfont-var-exclamation-triangle-fill:before {
    color: #b2611f;
  }

  .alert.alert-with-icon {
    border: unset;
  }

}

#reset-dismissals {
  margin-bottom: 20px;
}
</style>